import * as React from "react";
const ReactModal = require('react-modal');
import EventModal from "./event-modal";
import moment from "moment";
export default class EventItem extends React.Component {
    constructor(props) {
        super(props);
        this.toggleModal = () => {
            this.setState({ toggle: !this.state.toggle });
        };
        this.onClick = () => {
            this.props.updateSelectedEvent ?
                this.props.updateSelectedEvent() :
                this.toggleModal();
        };
        this.onError = () => {
            this.setState({ imgPath: "" });
        };
        this.state = {
            toggle: false,
            imgPath: this.props.imgPath || ""
        };
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ imgPath: nextProps.imgPath });
    }
    render() {
        let imgPath = this.state.imgPath;
        let img = imgPath ? React.createElement("div", { className: "event-img", style: { display: 'none' } },
            React.createElement("img", { alt: "pic", src: imgPath, onError: this.onError })) : null;
        let modal = this.state.toggle ?
            React.createElement(EventModal, Object.assign({}, this.props, { imgPath: imgPath, toggle: this.state.toggle, toggleModal: this.toggleModal }))
            : null;
        let timeformat = moment(new Date(this.props.StartDate)).format('L') === moment(new Date(this.props.EndDate)).format('L') ?
            "h:mm A" : "MMM DD YYYY, h:mm A";
        let time = `${moment(new Date(this.props.StartDate)).format('h:mm A')} - ${moment(new Date(this.props.EndDate)).format(timeformat)}`;
        return (React.createElement("div", { className: "product-event", onClick: this.onClick },
            modal,
            img,
            React.createElement("p", { className: "time" }, time),
            React.createElement("p", { className: "event-title" }, this.props.Name),
            React.createElement("p", { className: "event-location" }, this.props.LocationName)));
    }
}
;
//# sourceMappingURL=event-item.js.map